export const initialState = {
    filter: {
        effectiveStartDate : null,
        effectiveEndDate: null,
        nameKeyword: null,
        status: null,  
        page: null,
        size: null
    },
    isFilter: false,
    typeAction: null
  };
  
  const answerQuestionarySearchReducer = (state = initialState, action) => {
    switch (action.type) {
      case "FILTER_QUESTIONARY_ANSWER":
        return {
          ...state,
          filter: action.filter,
          isFilter: action.isFilter,
          typeAction: action.typeAction,
          page: action.page,
          size: action.size
        };
      default:
        return state;
    }
  };
  
  export default answerQuestionarySearchReducer;
  